import script from "./DivisionTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./DivisionTable.vue?vue&type=script&setup=true&lang=ts"

import "./DivisionTable.vue?vue&type=style&index=0&id=b4521c24&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4521c24"]])

export default __exports__